// Custom logo for Lift Up Reading
// An open book with an upward arc — symbolizing pages opening + a learner rising.

export function LogoMark({ size = 36, primary = "#2D5D4E", accent = "#7D2F2F", className = "" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
        >
            {/* Open book base */}
            <path
                d="M6 14 Q6 12 8 12 L22 12 Q24 12 24 14 L24 38 Q24 36 22 36 L8 36 Q6 36 6 38 Z"
                fill={primary}
            />
            <path
                d="M42 14 Q42 12 40 12 L26 12 Q24 12 24 14 L24 38 Q24 36 26 36 L40 36 Q42 36 42 38 Z"
                fill={primary}
                opacity="0.82"
            />
            {/* Page lines on left */}
            <line x1="10" y1="18" x2="20" y2="18" stroke="#FAF9F6" strokeWidth="1.4" strokeLinecap="round" />
            <line x1="10" y1="22" x2="18" y2="22" stroke="#FAF9F6" strokeWidth="1.4" strokeLinecap="round" />
            {/* Page lines on right */}
            <line x1="28" y1="18" x2="38" y2="18" stroke="#FAF9F6" strokeWidth="1.4" strokeLinecap="round" />
            <line x1="28" y1="22" x2="36" y2="22" stroke="#FAF9F6" strokeWidth="1.4" strokeLinecap="round" />
            {/* Lifting arc — upward growth */}
            <path
                d="M14 30 Q24 18 34 30"
                stroke={accent}
                strokeWidth="2.4"
                strokeLinecap="round"
                fill="none"
            />
            {/* Arrow tip on the arc */}
            <path
                d="M30 28 L34 30 L33 25.6"
                stroke={accent}
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
}

export function Wordmark({ className = "", showTagline = false }) {
    return (
        <div className={`flex flex-col leading-none ${className}`}>
            <span
                className="font-semibold text-xl tracking-tight text-[#1C2321]"
                style={{ fontFamily: "Outfit", letterSpacing: "-0.015em" }}
            >
                Lift Up <span className="text-[#2D5D4E]">Reading</span>
            </span>
            {showTagline && (
                <span className="text-[0.65rem] tracking-[0.18em] uppercase text-[#819888] mt-1 font-medium">
                    Reading, for grown-ups
                </span>
            )}
        </div>
    );
}

export default function Logo({ size = 36, showTagline = false, className = "" }) {
    return (
        <div className={`flex items-center gap-2.5 ${className}`}>
            <LogoMark size={size} />
            <Wordmark showTagline={showTagline} />
        </div>
    );
}
